import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import ApplicationHeader from 'shared/components/ApplicationHeader/index'
import {Footer, ScrollTop} from '@sabre/spark-react'
import 'sabre-spark/dist/css/spark.light.css'


class ScreenTemplate extends PureComponent {
    render() {
        return (
            <div className="spark-content--sticky-footer">
                <div className='spark-content__wrapper--sticky-footer'>
                    <ScrollTop/>
                    <ApplicationHeader login={this.props.login}
                                       activeMenuItem={this.props.activeMenuItem}
                                       message={this.props.message}/>
                    <main className="spark-main--sticky-footer" id="content">
                        <div className="container-fluid">
                            <div className="row spark-margin-bottom--lg spark-margin-top--lg">
                                {this.props.children}
                            </div>
                        </div>
                    </main>
                    <Footer/>
                </div>
            </div>
        )
    }
}

ScreenTemplate.propTypes = {
    message: PropTypes.object,
    login: PropTypes.string.isRequired,
    activeMenuItem: PropTypes.string.isRequired
}

export default ScreenTemplate






// WEBPACK FOOTER //
// ./src/shared/components/ScreenTemplate.js